/**
 * @generated SignedSource<<4cf10251c67c1b94da2e7c2d4df99441>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      }
    ],
    "concreteType": "DefaultFont",
    "kind": "LinkedField",
    "name": "defaultFont",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fontSize",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QDefaultFontQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QDefaultFontQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9601e682364465d40041216543d40550",
    "id": null,
    "metadata": {},
    "name": "QDefaultFontQuery",
    "operationKind": "query",
    "text": "query QDefaultFontQuery(\n  $teamId: ID!\n) {\n  defaultFont(teamId: $teamId) {\n    id\n    teamId\n    value\n    fontSize\n    unit\n  }\n}\n"
  }
};
})();

node.hash = "5c78cd6810d4fc9d527b0d1e07a3fc3a";

export default node;
